<template>   
<div>
<div class="display" :class=" {selected: selected, off: state =='off'}">
    
    <!--div v-if="selected" class="close-selected"><b-icon icon="x-lg" variant="danger"></b-icon></div-->        
      
    <div class="display-header">
        <b-icon v-if="!status || status == 'ok'" icon="check-square-fill" scale='1' variant="success" :title="$t('infopoints.states.ONLINE')"></b-icon>
        <b-icon v-if="status == 'error'" icon="exclamation-triangle-fill" scale='1' variant="danger" :title="$t('infopoints.states.OFFLINE-1')"></b-icon>
        <b-icon v-if="status == 'warning'" icon="exclamation-triangle-fill" scale='1' variant="warning" title="Laitteen levytilaa jäljellä 4%."></b-icon>
        <b-icon v-if="state == 'off'" icon="circle-fill" title="Näyttö pimennetty"></b-icon>
        <div class='display-id'> {{ id }}</div>
    </div>
    <div class="display-screen">
        <img v-if="status == 'error'" :src="this.notfound" title="Kuva ei saatavilla" />
        <img v-else :src="this.mockup" title="-" />
    </div>
    
    <div class='status'>
        <div class="status-rows">
        <div v-if="!status || status == 'ok'">
            <b-icon icon="check-square-fill" variant="success"></b-icon>
            <div class='time'>{{ currentDate }}</div>
            <div class='msg'>Yhteys ja toiminta OK.</div>
        </div>
        <div v-if="status == 'error'">
            <b-icon icon="exclamation-triangle-fill" variant="danger"></b-icon>
            <div class='time'>{{ currentDate }}</div>
            <div class='msg'>Ei yhteyttä laitteeseen.</div>
        </div>
        <div v-if="status == 'warning'">
            <b-icon icon="exclamation-triangle-fill" variant="warning"></b-icon>
            <div class='time'>{{ currentDate }}</div>
            <div class='msg'>Laitteen levytilaa jäljellä 4%.</div>
        </div>
        <div v-if="state == 'off'">
            <b-icon icon="circle-fill"></b-icon>
            <div class='time'>{{ currentDate }}</div>
            <div class='msg'>Näyttö pimennetty.</div>
        </div>

        </div>
        <div class="actions">
            <t-button type="icon" icon="info-lg" title="Vain tiedotteet" class="only-info"></t-button>
            <t-button v-if="state == 'off'" type="icon" icon="power" title="Käynnistä" class="ok"></t-button>
            <t-button v-else type="icon" icon="power" title="Sammuta" class="rm"></t-button>
            <t-button type="icon" icon="arrow-clockwise" title="Käynnistä uudelleen"></t-button>
      </div>
       
</div>

</div>        

</div>
</template>

<script>

import moment from "moment";

export default {
    props: ['id', 'status', 'selected', 'state'],
    
    data: function() {
        return  {
            mockup: "/traveller-ui/static/traveller/img/metro-display.png",
            notfound: "/traveller-ui/static/traveller/img/not-found-960x270.png"
        }
    },

    computed: {
        currentDate(){
            return moment().format("D.M.YYYY HH:mm:ss");
        }
    }
}
</script>